import produce from "immer";
import { v1 as uuid } from "uuid";
import { addNotificationRemovingSameOnes } from "@Utils/notifications";
import { NotificationsState } from "../";

export interface AddNotificationByCodeAction {
  type: "addNotificationByCode";
  code: string;
  message?: string;
}

export const addNotificationByCode = (
  state: NotificationsState,
  action: AddNotificationByCodeAction
): NotificationsState => {
  return produce(state, (draftState) => {
    const { code, message } = action;

    addNotificationRemovingSameOnes(draftState.notifications, {
      code,
      key: uuid(),
      message,
    });
  });
};
